import React from "react";
import CaseStudySticky from "./CaseStudySticky";
import CaseStudyText from "./CaseStudyText";
import { useQuery } from "react-query";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import CaseStudyResponsive from "./CaseStudyResponsive";
import "./tabel.css";
import PageTitleCard from "../../templates/PageTitleCard";
import PageHeading from "../../../templates/PageHeading";
import useGetData from "../../../../hooks/apihooks/useGetData";
import SubHeadingText from "../../../common/SubHeadingText";
import CurrentPath from "../../../templates/CurrentPath";
import RightArrow from "../../../templates/RightArrow";
import BackHome from "../../../templates/BackHome";

const CaseStudy = () => {
  const { data, isLoading, isError } = useGetData("case_study", "getCaseStudy");

  return (
    <>
      <PageTitleCard>
        <PageHeading>Case Studies</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Case Studies</CurrentPath>
        </div>
      </PageTitleCard>
      <div className="py-8 lg:max-w-screen-xl mx-auto md:px-4 sm:px-8  max-sm:px-8">
        <SubHeadingText>Case Studies</SubHeadingText>

        <div className="flex w-full  py-8">
          <div className="w-1/2 p-8 lg:block md:hidden sm:hidden max-sm:hidden ">
            <CaseStudyText data={data} />
          </div>

          <div className="w-1/2 p-24 lg:block md:hidden sm:hidden max-sm:hidden">
            <CaseStudySticky data={data} />
          </div>
          <div className="lg:hidden md:block sm:block max-sm:block">
            <CaseStudyResponsive data={data} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseStudy;
